import { createI18n as CreateI18n } from 'vue-i18n';
const messages = {
  zh: {
    logoImgAlt: 'Hi ECAEX logo,视频会议,电话会议,在线文档,移动办公协同软件',
    logoImgAlt2: '下载页logo',
    topTitle: '下载 Hi ECARX 客户端',
    version: '支持 Windows，macOS，iOS，iPadOS，Android，Linux 版本',
    windows: 'Windows 客户端',
    downloadBtn: '点击下载',
    macOS: 'macOS 客户端',
    supportM1: '支持 M1 版本',
    'iOS&iPadOS': 'iOS 和 iPadOS 客户端',
    scanDownload: '扫码下载',
    coming: '敬请期待',
    android: 'Android 客户端',
    linux: 'Linux 客户端',
    supportDebx64: '支持deb x64',
    copyright:
      'Copyright © 2022, ECARX Co., Ltd. All Rights Reserved. 鄂ICP备2022004603号-1',
    macVersion: '选择适合你的 Mac 的版本',
    cantRun: '为了确保Hi ECARX正常使用，请选择合适的下载版本。',
    adviseIntel:
      '如果不确定你的 Mac 使用哪个芯片类型，建议下载Intel 芯片版本，',
    enSureUse: 'Apple 芯片版本在 Intel 芯片的机型上无法正常使用。',
    discernType: '如何确认芯片类型？',
    step1: '在左上角，点击<b>Apple 菜单 > 关于本机</b>',
    step2:
      '在<b>“概览”</b>标签页中，寻找<b>“处理器”</b>或<b>“芯片”</b>确认显示的是“Intel”还是“Apple”',
    interClip: '下载 Intel 芯片版',
    appleClip: '下载 Apple 芯片版',
    step1Img: '../assets/img/step1.webp',
    step2Img: '../assets/img/step2.webp',
    imgType: 'ch',
    downloadNow: '立即下载',
    iOSInstall: 'Hi ECARX 专版iOS安装',
    installCode: '兑换码: ',
    cancel: '暂不下载',
    appDisplayImg: './assets/img/logo/app_display.png',

    supportDifferentRegion: '支持不同地区',
    supportDifferentRegionTip:
      '* 根据您苹果ID所在区域，会提供相应的应用兑换码。',
    selectRightCode: '选择适合你的二维码',
    China: '中国',
    Sweden: '瑞典',
    England: '英国',
    USA: '美国',
    HK: '香港',
    DE: '德国',

    pleaseSelect: '请选择',
    pleaseSelectRegion: '请选择地区',
    pleaseSelectRegionTip: '根据您选择的苹果ID所在区域，会提供下载兑换码。',
    cancelSelect: '取消',
    region: '地区',
    client: '客户端',
  },
  en: {
    logoImgAlt:
      'Hi ECAEX logo,video meeting,phone meeting,online document,mobile office collaboration software',
    logoImgAlt2: 'download page logo',
    topTitle: 'Download Hi ECARX Client',
    version: 'Support Windows, macOS, iOS, iPadOS, Android, Linux version',
    windows: 'Windows Client',
    downloadBtn: 'Click to download',
    macOS: 'macOS Client',
    supportM1: 'Support M1 version',
    'iOS&iPadOS': 'iOS and iPadOS Client',
    scanDownload: 'Scan to download',
    coming: 'Coming soon',
    android: 'Android Client',
    linux: 'Linux Client',
    supportDebx64: 'Support deb x64',
    copyright: ' ',
    macVersion: 'Which version of Hi ECARX?',
    cantRun:
      'To ensure Hi ECARX works properly, please check which chip your Mac has.',
    adviseIntel:
      "If you're not sure which chip your Mac computer has, download the Intel chip version to ensure usability.",
    enSureUse:
      "Hi ECAEX for Mac with Apple chips can't run on those with Intel chips.",
    discernType: 'Check which chip your Mac has',
    step1: 'At the top left, click the <b>Apple menu > About this Mac</b>',
    step2:
      'In the <b>Overview</b> tab, look for the word "<b>processor</b>" or "<b>chip</b>", and check if it says "Intel" or "Apple"',
    interClip: 'Intel clip',
    appleClip: 'Apple clip',
    step1Img: '../assets/img/step1_en.webp',
    step2Img: '../assets/img/step2_en.webp',
    imgTypeL: 'en',
    downloadNow: 'Download',
    iOSInstall: 'Hi ECARX iOS Installation',
    installCode: 'Code: ',
    cancel: 'Cancel',
    appDisplayImg: './assets/img/logo/app_display_en.webp',

    supportDifferentRegion: 'Support many regions',
    supportDifferentRegionTip:
      'According to the location of your Apple ID, the download code will be provided.',
    selectRightCode: 'Choose the right version',
    China: 'China',
    Sweden: 'Sweden',
    England: 'United Kingdom',
    USA: 'United States',
    HK: 'Hong Kong',
    DE: 'Germany',

    pleaseSelect: 'Region',
    pleaseSelectRegion: 'Region',
    pleaseSelectRegionTip:
      'According to the location of your AppleID, the download code will be provided.',
    cancelSelect: 'Cancel',
    region: 'Region',
    client: 'Client',
  },
};
const locale = (navigator.language || navigator.browserLanguage || 'zh-cn')
  .toLowerCase()
  .slice(0, 2);
if (locale === 'zh') {
  document.title = 'Hi ECARX - 开启亿咖通高效办公之旅';
} else {
  document.title = 'Hi ECARX - Start an efficient work journey in ECARX';
}
// 通过选项创建 VueI18n 实例
const i18n = new CreateI18n({
  locale, // 设置地区
  messages, // 设置地区信息
});
export default i18n;
